<template>
  <div class="home">
    <div>
      <div>
        <section>
          <div class="py-8 px-8">
            <div class="d-flex flex-wrap align-items-center justify-content-between">
              <div class="col-12 col-lg-auto mb-4 mb-lg-0">
                <div class="d-flex align-items-center">
                  <h4 class="mb-0 me-2">{{$t('bank_accounts')}}</h4>
                </div>
              </div>
              <div class="col-12 col-lg-auto d-flex align-items-center">
                <div class="input-group pe-4 bg-white rounded border">
                  <input class="form-control border-0" type="text" v-model="keyword" :placeholder="$t('search')">
                  <button class="btn p-0" type="button">
                    <AppIcon name="bi-search" class="bi bi-search" style="font-size:18px" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section class="">
        <div class="px-8">
          <div class="row align-items-end g-3 mb-4">
            <div class="col"></div>
            <div class="col-md-3 col-lg-2">
              <select v-model="status" class="form-select">
                <option value="all">{{$t('all')}}</option>
                <option value="active">{{$t('active')}}</option>
                <option value="inactive">{{$t('inactive')}}</option>
              </select>
            </div>
            <div class="col-md-2">
              <button @click="openAddModal" class="btn-sm btn btn-success w-100">
                <span class="d-inline-block me-2">
                  <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                </span>
                <span>{{$t('bank_account')}}</span>
              </button>
            </div>
          </div>
          <div class="page-table-container mb-6 bg-white rounded shadow">
            <!-- Table -->
          <div class="table-responsive">
            <table class="table mb-0 table-borderless table-striped small">
              <thead>
                <tr class="text-secondary">
                  <sortable-table-header field="account_name" label="account_name" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getBankAccounts)" />
                  <sortable-table-header field="bank_name" label="bank_name" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getBankAccounts)" />
                  <sortable-table-header field="account_number" label="account_number" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getBankAccounts)" />
                  <sortable-table-header field="currency" label="currency" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getBankAccounts)" />
                  <sortable-table-header field="balance" label="balance" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getBankAccounts)" />
                  <sortable-table-header field="status" label="status" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getBankAccounts)" />
                  <sortable-table-header field="created_at" label="created_at" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getBankAccounts)" />
                  <th class="pt-4 pb-3 px-6">{{$t('created_by')}}</th>
                  <th class="pt-4 pb-3 px-6">{{$t('action')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="account in bankAccounts" :key="account.id">
                  <td class="py-5 px-6">
                    <router-link :to="`/bank-accounts/${account.id}`">
                      <b>{{account.account_name}}</b>
                    </router-link>
                  </td>
                  <td class="py-5 px-6">{{account.bank_name}}</td>
                  <td class="py-5 px-6">{{account.account_number}}</td>
                  <td class="py-5 px-6">{{account.currency}}</td>
                  <td class="py-5 px-6">{{formatMoney(account.balance)}}</td>
                  <td class="py-5 px-6">
                    <span :class="account.status === 'active' ? 'badge bg-success' : 'badge bg-secondary'">
                      {{$t(account.status)}}
                    </span>
                  </td>
                  <td class="py-5 px-6">{{formatDate(account.created_at)}}</td>
                  <td class="py-5 px-6">{{account.user ? account.user.name : '-'}}</td>
                  <td class="py-5 px-6">
                    <button @click="goDetails(account.id)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                      <AppIcon name="bi-eye" class="bi bi-eye" />
                      {{$t('details')}}
                    </button>
                    <button @click="editAccount(account)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                      <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                      {{$t('edit')}}
                    </button>
                    <button @click="deleteAccount(account)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs">
                      <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                      {{$t('delete')}}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="count > bankAccounts.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
              <compact-pagination :pages="pagination" :current-page="page" @change="getBankAccounts" />
            </div>
          </div>

          <table-loading-bar v-if="loading" class="page-table-state text-center" />
          <div v-if="loading === false && !bankAccounts.length" class="page-table-state text-center" style="padding:1rem">{{$t('no_accounts_found')}}.</div>
        </div>

          <div class="col-sm-6">
            {{$t('show')}}
            <select v-model="per_page" class="form-select mb-3" name="Results" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
            {{$t('entities')}}
          </div>
        </div>
      </section>
    </div>

    <!-- Add/Edit Modal -->
    <add-edit-bank-account-modal 
      v-if="modalOpen" 
      @modalClosed="modalOpen = false"
      :isModalOpen="modalOpen" 
      :data="selectedAccount" 
      :action="modalAction"
      @refresh="refresh"
    ></add-edit-bank-account-modal>
  </div>
</template>

<script>
import helper from '../../helper'
import moment from 'moment'
import AddEditBankAccountModal from '../../components/bank-account/AddEditBankAccountModal.vue'
import sortableList from '../../mixins/sortableList'

export default {
  name: 'BankAccount',
  persistedFilterState: {
    key: 'bank-accounts',
    fields: ['keyword', 'status', 'per_page', 'sortField', 'sortDirection'],
  },
  mixins: [sortableList],
  components: {
    AddEditBankAccountModal
  },
  data() {
    return {
      keyword: '',
      bankAccounts: [],
      count: 0,
      page: 1,
      per_page: 10,
      status: 'all',
      loading: false,
      modalOpen: false,
      modalAction: 'create',
      selectedAccount: null,
      helper
    }
  },
  computed: {
    pagination() {
      const pages = Math.ceil(this.count / this.per_page)
      return Array.from({ length: pages }, (_, i) => i + 1)
    },
    activeAccountsCount() {
      return this.bankAccounts.filter(acc => acc.status === 'active').length
    },
    totalBalance() {
      return this.bankAccounts.reduce((sum, acc) => sum + (acc.balance || 0), 0)
    }
  },
  mounted() {
    window.mixpanel.track("bank_accounts");
    this.getBankAccounts()
  },
  watch: {
    keyword() {
      this.page = 1
      this.getBankAccounts()
    },
    per_page() {
      this.page = 1
      this.getBankAccounts()
    },
    status() {
      this.page = 1
      this.getBankAccounts()
    }
  },
  methods: {
    async getBankAccounts(page = 1) {
      try {
        this.loading = true
        this.page = page
        const params = new URLSearchParams({ page: this.page, per_page: this.per_page })
        this.appendSortParams(params)
        
        if(this.status && this.status !== 'all'){
          params.append('status', this.status)
        }
        
        if(this.keyword){
          params.append('keyword', this.keyword)
        }
        const url = `${process.env.VUE_APP_API}/bank-accounts?${params.toString()}`
        const response = await helper.customGet(url)
        this.bankAccounts = response.data.data
        this.count = response.data.count
        this.loading = false
      } catch (error) {
        this.loading = false
        alert(error)
      }
    },
    openAddModal() {
      this.selectedAccount = null
      this.modalAction = 'create'
      this.modalOpen = true
    },
    goDetails(id) {
      this.$router.push(`/bank-accounts/${id}`)
    },
    editAccount(account) {
      this.selectedAccount = account
      this.modalAction = 'edit'
      this.modalOpen = true
    },
    async deleteAccount(account) {
      if (!confirm(this.$t('confirm_delete'))) return
      
      try {
        await helper.customDelete(`${process.env.VUE_APP_API}/bank-accounts/${account.id}`, {showToast: true})
        this.bankAccounts = helper.withoutDeletedRecords(this.bankAccounts, account.id)
        this.count = Math.max(0, this.count - 1)
      } catch (error) {
        alert(error)
      }
    },
    refresh() {
      this.getBankAccounts()
    },
    formatMoney(amount) {
      return helper.formatMoney(amount)
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>
